var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotification(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.2983 10.1897C16.6591 9.44325 16.3687 8.79642 16.3687 7.69751V7.32386C16.3687 5.89184 16.0391 4.96918 15.3225 4.04652C14.2181 2.61362 12.3588 1.75 10.5387 1.75H10.4613C8.67943 1.75 6.87843 2.57396 5.75487 3.9487C4.99916 4.88987 4.63131 5.85219 4.63131 7.32386V7.69751C4.63131 8.79642 4.35999 9.44325 3.70168 10.1897C3.21729 10.7396 3.0625 11.4463 3.0625 12.2112C3.0625 12.977 3.31382 13.7023 3.81821 14.2919C4.47652 14.9986 5.40615 15.4498 6.35578 15.5282C7.73067 15.6851 9.10555 15.7441 10.5004 15.7441C11.8944 15.7441 13.2693 15.6454 14.6451 15.5282C15.5939 15.4498 16.5235 14.9986 17.1818 14.2919C17.6853 13.7023 17.9375 12.977 17.9375 12.2112C17.9375 11.4463 17.7827 10.7396 17.2983 10.1897Z",
    fill: "#E9A5F3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M12.258 16.8249C11.8206 16.7315 9.15519 16.7315 8.71777 16.8249C8.34383 16.9113 7.93945 17.1122 7.93945 17.5528C7.96119 17.9732 8.2073 18.3442 8.54819 18.5795L8.54732 18.5804C8.98823 18.9241 9.50565 19.1426 10.0474 19.221C10.3361 19.2607 10.6301 19.2589 10.9292 19.221C11.4701 19.1426 11.9876 18.9241 12.4285 18.5804L12.4276 18.5795C12.7685 18.3442 13.0146 17.9732 13.0363 17.5528C13.0363 17.1122 12.632 16.9113 12.258 16.8249Z",
    fill: "#E9A5F3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotification);
export default __webpack_public_path__ + "static/media/Notification.61db17c28259cf4512bed43ad0504026.svg";
export { ForwardRef as ReactComponent };